import React from 'react';
import {
    Select, SelectContent, SelectItem, SelectTrigger, SelectValue
} from 'shared/components/ui/select';

// Define the types for the props
interface TypeOption {
    value: string;
    name: string;
}

interface FilterBarProps {
    selectType: string;
    setSelectType: (value: string) => void;
    allListings: any[];
    setListings: (listings: any[]) => void;
    itemType?: string;
    types: TypeOption[];
    placeholder: string;
}

export function FilterBar({
    selectType,
    setSelectType,
    allListings,
    setListings,
    itemType = 'type',
    types,
    placeholder
}: FilterBarProps) {

    const onChange = (value: string) => {
        setSelectType(value);
        if (value === 'All') {
            setListings(allListings);
        } else {
            setListings(allListings.filter(item => item[itemType] === value));
        }
    };

    return (
        <Select onValueChange={onChange} value={selectType}>
            <SelectTrigger className="w-[180px]">
                <SelectValue placeholder={placeholder} />
            </SelectTrigger>
            <SelectContent>
                {types.map((type) => (
                    <SelectItem key={type.value} value={type.value}>
                        {type.name}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}
